Vue.component("manage-menu-format-component", require("./Manage.vue").default);
